// Components
import { IconPen, Button } from '@tracklib/kit'
import TrackSampled from 'components/usersong/sample/tracksampled'
import PageHeader from 'components/usersong/pageheader'

// Types
import { UserSong } from 'types'

import styles from './sample.css'

type UserSongOverviewProps = {
  userSong: UserSong
}

const UserSongOverview = ({ userSong }: UserSongOverviewProps): JSX.Element => {
  const sample = userSong.samples[0]
  return (
    <>
      <PageHeader title="Sample overview" subtitle="The following is an overview of the sample use in your new song." />
      <div className={styles.detailBoxWrapper}>
        <div>
          <TrackSampled sample={sample} />

          {userSong.state === 'UNLICENSED' && (
            <>
              <div className={styles.footerDivider} />
              <div className={styles.actions}>
                <Button variant="outline" to="usersong" modal query={{ userSongId: userSong.id }} className={styles.editButton}>
                  <IconPen /> Edit
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default UserSongOverview
